import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RegnskabsaarTilGodkendelseService} from './regnskabsaar-til-godkendelse.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KlarTilGodkendelseViewModel } from '@store/models';

@Component({
    selector: 'app-regnskabsaar-til-godkendelse',
    templateUrl: './regnskabsaar-til-godkendelse.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RegnskabsaarTilGodkendelseComponent {
    regnskabsaarTilGodkendelse$ = this.regnskabsaarTilGodkendelseService.getRegnskabsaarTilGodkendelseView();

    constructor(
        private regnskabsaarTilGodkendelseService: RegnskabsaarTilGodkendelseService,
        private router: Router,
        private modal: NgbActiveModal
    ) {
    }

    onClose() {
        this.modal.close();
    }

    async onGotoGodkendelse(item: KlarTilGodkendelseViewModel) {
        await this.router.navigate(['clients', item.kid, 'regnskabsaar', item.regnskabsaarId, 'kundeaccept']);
        this.modal.close();
    }
}
